import "./index.css";
import { QRCodeSVG } from "qrcode.react";

const ZALO_SUPPORT_GROUP_URL = process.env.REACT_APP_ZALO_SUPPORT_GROUP_URL;

function SupportGroupCard({ url = ZALO_SUPPORT_GROUP_URL }) {
  return (
    <aside className="support-group-card" aria-label="Nhóm hỗ trợ kĩ thuật">
      <p className="support-group-card__title">Nhóm hỗ trợ kĩ thuật</p>
      <a
        className="support-group-card__btn"
        href={url}
        target="_blank"
        rel="noopener noreferrer"
      >
        Vào nhóm
      </a>
      <div className="support-group-card__qr">
        <QRCodeSVG
          value={url}
          size={156}
          level="M"
          bgColor="#ffffff"
          fgColor="#1a1208"
        />
      </div>
    </aside>
  );
}

export default SupportGroupCard;
